import type { Operation } from '@urql/core';
import type { DocumentNode } from 'graphql';

/**
 * Narrows an operation's GraphQL query to graphql's `DocumentNode`.
 *
 * urql types `operation.query` as `DocumentNode | PersistedDocument | TypedDocumentNode`.
 * Since `@0no-co/graphql.web` 1.3.x, its `PersistedDocument` member no longer carries the
 * AST fields (e.g. `definitions`) and is no longer assignable to graphql's `ASTNode`, which
 * breaks both direct AST access and `visit()`. We never use persisted documents, so the
 * query is always a full AST document — narrow it back to `DocumentNode` at the access site.
 */
export function getOperationDocument(operation: Operation): DocumentNode {
    return operation.query as DocumentNode;
}
